import * as React from "react";

import { EntityView } from "api/generated/model";
import { AssignEntities } from "org/risks/widgets/assignEntities";
import { FormComponentProps, subForm } from "utils/form";

class CreateNodeEntitiesTab<ROOT> extends React.PureComponent<
    CreateNodeEntitiesTabProps<ROOT>
> {
    render = () => {
        const { form, ancestorsEntities, entities } = this.props;
        const entitiesForm = subForm("entities", form);

        return (
            <AssignEntities
                type="CREATE"
                id="nodeEntities"
                initialValue={[]}
                form={entitiesForm}
                canDeleteEntityLink={true}
                confirmUnassign={false}
                ancestorsEntities={ancestorsEntities}
                entities={entities}
            />
        );
    };
}

interface CreateNodeEntitiesTabProps<ROOT> extends FormComponentProps<
    "entities",
    CreateNodeEntitiesTabValues,
    ROOT
> {
    ancestorsEntities: Record<number, string>;
    entities: Record<number, EntityView>;
}

interface CreateNodeEntitiesTabValues {
    nodeEntities: number[];
}

export {
    CreateNodeEntitiesTab,
    type CreateNodeEntitiesTabProps,
    type CreateNodeEntitiesTabValues,
};
